export const SET_STATE = (state, { key, value }) => {
  state[key] = value;
};

export const TOGGLE_DARKMODE = (state) => {
  state.darkmode = !state.darkmode;
};

export const TOGGLE_AUTOPLAY = (state) => {
  state.autoPlay = !state.autoPlay;
};

export const INITIALIZE = (state) => {
  state.isInitialized = true;
  state.darkmode = false;
  state.autoPlay = true;
};
